<template>
  <div class="top-menu">
        <ul class="nav nav-tabs justify-content-center">
            <li class="nav-item">            
                <router-link class="nav-link active" to="/admin_config">Config site</router-link>
            </li>
            <li class="nav-item">
                <router-link class="nav-link" to="/admin_articles">Articles</router-link>
            </li>
            <li class="nav-item">
                <router-link class="nav-link" to="/admin_categories">Categories</router-link>
            </li>
            <li class="nav-item">
                <router-link class="nav-link" to="/admin_menu">Menu</router-link>
            </li>
            <li class="nav-item">
                <router-link class="nav-link" to="/admin_gallery">Gallery</router-link>
            </li>
            <li class="nav-item">
                <router-link class="nav-link" to="/admin_comments">Comments</router-link>
            </li>
            <li class="nav-item" style="display:none;">
                <router-link class="nav-link" to="/admin_banners">Banners</router-link>
            </li>
        </ul>
  </div>
</template>

<script>
import { getDataFromServer } from '../../utils/DataProvider'
import { InitSource } from '../../sources/language_provider'
  export default {
    created(){
      //get site data
      getDataFromServer('get_homepage_data', null)
      .then(obj => { 
        this.$store.dispatch('INIT_SITE_DATA', obj.data)
        this.$store.dispatch('SET_CURRENT_LANGUAGE', obj.data.config.data.language)
      })
      .catch(err => { })
    },
  }
</script>

<style>
  .container-admin{
    background-color: #fff;
    padding: 20px;
    border: solid 1px #ccc;
    border-radius: 7px; 
  }

  .container-admin h3{
    text-decoration: underline;
  }

  .list-row{
    display: flex;
    justify-content: space-between;
    border-bottom: solid 1px #ccc;
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 5px;
    height: 40px;
    margin-top: 10px;
  }

  .list-row:hover{
    background-color: #ccc;       
  }

  .list-row a{
    text-transform: uppercase;
    letter-spacing: 1px;
    font-size: 14px;
  }
  .list-row a:hover{
    color: #2a6496;
    text-decoration: underline;       
  }

  .list-row span{
    margin-right: 15px;
    margin-left: 15px;
  } 

  .navbar-cust{    
    margin-bottom: 30px;
  }

  .list-row button{
    color: #666;
    font-weight: unset;
    text-shadow: unset;
  }

  .d-flex{
    display: flex;
  }

  .w-100{
    width: 100%;
  } 
  
</style>


